import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { theme } from 'antd';
import { RootState } from 'store/configureStore';
import TitleBar from 'components/TitleBar';
import GoBackButton from 'components/GoBackButton';
import CardComponent from 'components/CardComponent';
import dependencyAreas from 'constants/dependency';
import { useTranslation } from 'react-i18next';
import * as Styled from 'components/Layouts/Layout.styled';

const { useToken } = theme;

const Dependencies: React.FC = () => {
  const { token } = useToken();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dependencyArea = dependencyAreas(t);
  const lang = useSelector((state: RootState) => state.global.lang);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedArea = decodeURIComponent(query.get('selected') || '');
  const { scheme } = useSelector((state: RootState) => state.global);

  const handleCardClick = (item: {
    area: string;
    title: string;
    href: string;
  }) => {
    if (item.href) {
      navigate(item.href);
    }
  };

  return (
    <Styled.StyledLayout token={token}>
      <TitleBar
        title={t ? t('DEPENDENCY_TREE') : 'Dependency Tree'}
        goBackButtons={
          <GoBackButton to='/working_area' text={t('GO_TO_WORKING_AREAS')} />
        }
      />
      <Styled.HorizontalLayout theme={scheme}>
        <Styled.Container>
          <Styled.GridContainer token={token}>
            {dependencyArea.map((item) => (
              <Styled.RelativeContainer
                key={item.area}
                onClick={() => handleCardClick(item)}
              >
                <CardComponent
                  area={item.title}
                  infoText={''}
                  href={item.href}
                  textOnTop=''
                />
              </Styled.RelativeContainer>
            ))}
          </Styled.GridContainer>
        </Styled.Container>
      </Styled.HorizontalLayout>
    </Styled.StyledLayout>
  );
};

export default Dependencies;
